import { View } from "tamagui";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import React from "react";

import { ProfileNavigatorParamList } from "../../../../navigators/ProfileNavigator";

import mixpanel from "../../../../../mixpanel";
import { MemberListItem } from "../../../../components/MemberListItem";
import { FlashList } from "@shopify/flash-list";
import { useApiQuery } from "../../../../../lib/api";
import type { MemberListItem as MemberListItemType } from "../../../../types/profile";

type MembersListProps = {
  searchTerm: string;
};

export const MembersList = ({ searchTerm }: MembersListProps) => {
  const navigation = useNavigation<NavigationProp<ProfileNavigatorParamList>>();

  const { data, isLoading, refetch } = useApiQuery<{
    members: MemberListItemType[];
  }>(
    ["members", searchTerm],
    `/api/v1/members?search=${encodeURIComponent(searchTerm)}&limit=50`,
  );

  const members = data?.members ?? [];

  const navigateToMember = (userId: string) => {
    mixpanel.track("Member Profile View", { userId });
    navigation.navigate("Member", { id: userId });
  };

  return (
    <FlashList
      contentContainerStyle={{ paddingBottom: 100 }}
      keyExtractor={(item) => item.id}
      showsVerticalScrollIndicator={false}
      ItemSeparatorComponent={() => <View h={1} bg="$gray4" />}
      data={members}
      onEndReachedThreshold={0.25}
      scrollEventThrottle={500}
      estimatedItemSize={67}
      refreshing={isLoading}
      onRefresh={() => refetch()}
      renderItem={({ item }) => {
        const role = item.roles?.[0]?.role ?? "Member";
        return (
          <MemberListItem
            id={item.id}
            name={item.name ?? ""}
            role={role}
            avatarUrl={item.avatar_url ?? null}
            onPress={navigateToMember}
          />
        );
      }}
    />
  );
};
